import { SearchResponseModelMerchandisingContentInline } from "@searchspring/snapi-types";
import { FC } from "react";
import styles from "./SearchSpringMerchandising.module.scss";

interface Props {
	content: Array<string> | undefined;
}

const SearchSpringMerchandising: FC<Props> = ({ content }) => {
	if (!content) {
		return null;
	}

	const html = content.join("");

	return (
		<div
			className={styles.wrapper}
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	);
};

export const SearchSpringInlineBanner: FC<
	SearchResponseModelMerchandisingContentInline
> = ({ value }) => {
	if (!value) {
		return null;
	}

	return (
		<article className={styles.card}>
			<div
				className={styles.inner}
				dangerouslySetInnerHTML={{ __html: value }}
			/>
		</article>
	);
};

export default SearchSpringMerchandising;
